import React, { useState, useEffect } from 'react';
import EmployeeGrid from '../../components/Employee/EmployeeGrid';
import EmployeeDetailsModal from '../../components/Employee/EmployeeDetailsModal';
import DeleteConfirmationModal from '../../components/Employee/DeleteConfirmationModal';
import PasswordManagement from '../../components/Profile/PasswordManagement';
import EmployeeForm from '../../components/employees/EmployeeForm';
import Pagination from '../../components/Employee/Pagination';
import { useToast } from '../../components/Admissionform/ToastManager'; // Update the path accordingly
import { fetchUserData } from "../../services/authServicepa";
import ProfileAvatarpp from '../../components/common/Avatar/ProfileAvatarpp';
import UserProfileDropdown from '../../components/common/Avatar/UserProfileDropdown';
import RecordCountCard from '../../components/Employee/RecordCountCard';
import EmployeeFilters from '../../components/Employee/EmployeeFilters';
import EmployeeFilterSummary from '../../components/Employee/EmployeeFilterSummary';
import ReplaceEmployeeModal from '../../components/Employee/ReplaceEmployeeModal';
import {
    fetchEmployees,
    updateEmployee,
    deleteEmployee,
    changeEmployeePassword,
    fetchRegDetails,
    replaceEmployeeMapping
} from '../../services/employeeServiceve';
import '../../styles/Placementdb.css';
import '../../styles/FilterStyles.css';
// import '../../styles/Advanced.css';
import '../../styles/ViewEmployees.css'
import '../../styles/ProfileAvatar.css'


const ViewEmployees = () => {
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [userRole, setUserRole] = useState("");
    const [branches, setBranches] = useState([]);
    const [locations, setLocations] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [editFormData, setEditFormData] = useState({});
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [passwordLoading, setPasswordLoading] = useState(false);
    const [availableLocations, setAvailableLocations] = useState([]);
    const [availableBranches, setAvailableBranches] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const { showSuccess, showError } = useToast();

    // Search and filter states - Updated to match backend
    const [searchQuery, setSearchQuery] = useState(''); // Unified search for name, role, email
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [IsSearching, setIsSearching] = useState(false);
    const [shouldFetch, setShouldFetch] = useState(false);
    const [noResultsFound, setNoResultsFound] = useState(false); // New state for no results
    const [selectedAccess, setSelectedAccess] = useState("");
    const [loginFrom, setLoginFrom] = useState("");
    const [loginTo, setLoginTo] = useState("");
    const [showReplaceModal, setShowReplaceModal] = useState(false);
    const [replaceEmployee, setReplaceEmployee] = useState(null);
    const [lastLoginFilter, setLastLoginFilter] = useState("");

    // Pagination states
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(10);
    // Load employees data
    useEffect(() => {

        loadEmployees();

    }, [
        page,
        limit,
        searchQuery,
        selectedBranches,
        selectedDepartments,
        selectedRoles,
        selectedAccess,
        lastLoginFilter,
        loginFrom,
        loginTo
    ]);
    const loadEmployees = async () => {
        setLoading(true);
        setError(null); // Clear previous errors
        setNoResultsFound(false); // Clear no results state

        try {
            // Build query parameters for API request - Updated to match backend
            let queryParams = { page, limit };

            // Use unified search parameter instead of separate name parameter
            if (searchQuery.trim()) {
                queryParams.search = searchQuery.trim();
            }

            if (selectedBranches.length > 0) {
                queryParams.branch = selectedBranches.join(",");
            }

            if (selectedDepartments.length > 0) {
                queryParams.department = selectedDepartments.join(",");
            }

            if (selectedRoles.length > 0) {
                queryParams.role = selectedRoles.join(",");
            }
            if (selectedAccess !== "") {

                queryParams.has_access =
                    selectedAccess;
            }
            if (lastLoginFilter) {

                queryParams.lastLoginFilter =
                    lastLoginFilter;

            }

            if (loginFrom) {

                queryParams.loginFrom =
                    loginFrom;

            }

            if (loginTo) {

                queryParams.loginTo =
                    loginTo;

            }
            const response = await fetchEmployees(queryParams);

            // Check if response has data
            if (response.data && response.data.length > 0) {
                setEmployees(response.data);
                setTotalPages(
                    response.pagination.totalPages
                );

                setTotalRecords(
                    response.pagination.totalRecords
                ); setNoResultsFound(false);
            } else {
                // No employees found - this is not an error, just empty results
                setEmployees([]);
                setTotalPages(1);
                setNoResultsFound(true);
            }

            setLoading(false);
            setIsSearching(false);
        } catch (err) {
            // Only set error for actual API failures, not empty results
            const errorMessage = err.response?.status === 404 || err.message?.includes('No employees found')
                ? null
                : 'Failed to fetch employees';

            if (errorMessage) {
                setError(errorMessage);
            } else {
                // Handle 404 or "no employees found" as empty results, not an error
                setEmployees([]);
                setTotalPages(1);
                setNoResultsFound(true);
            }

            setLoading(false);
            setIsSearching(false);
            console.error('Error fetching employees:', err);
        }
    };

    // Initial data load
    useEffect(() => {
        loadEmployees();
    }, []);

    // Load user data and available locations/branches
    useEffect(() => {

        const loadInitialData = async () => {

            try {

                // Fetch user data
                const userData = await fetchUserData();

                setUserRole(userData.role || "");
                setBranches(userData.branch || []);
                setLocations(userData.location || []);

                // Fetch available locations and branches
                const regDetails = await fetchRegDetails();

                if (regDetails.location) {
                    setAvailableLocations(regDetails.location);
                }

                if (regDetails.branch) {
                    setAvailableBranches(regDetails.branch);
                }

                // ==================================================
                // FETCH DEPARTMENTS
                // ==================================================

                const token = localStorage.getItem("token");

                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/alltech`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                const result = await response.json();

                if (result.success && Array.isArray(result.data)) {

                    const uniqueDepartments = [

                        ...new Set(

                            result.data
                                .map(item => item.Department)
                                .filter(Boolean)

                        )

                    ];

                    setDepartments(uniqueDepartments);

                }

            }

            catch (err) {

                console.error(
                    "Failed to fetch initial data:",
                    err
                );

            }

        };

        loadInitialData();

    }, []);
    const handleEditClick = (employee) => {
        const departmentValue = employee.department;
        let normalizedDepartment;

        if (Array.isArray(departmentValue)) {
            normalizedDepartment = departmentValue.map(d => {
                // Convert "Pumo Tech" to "Pumo Tech", "Pumo-Tech" to "Pumo Tech", etc.
                if (d.toLowerCase().includes("pumo")) return "Pumo Tech";
                if (d.toLowerCase().includes("cadd")) return "CADD";
                if (d.toLowerCase().includes("monz")) return "Monz-Creativeschool";
                return d.trim();
            });
        } else if (typeof departmentValue === 'string') {
            const depts = departmentValue.split(',').map(d => d.trim());
            normalizedDepartment = depts.map(d => {
                if (d.toLowerCase().includes("pumo")) return "Pumo Tech";
                if (d.toLowerCase().includes("cadd")) return "CADD";
                if (d.toLowerCase().includes("monz")) return "Monz-Creativeschool";
                return d;
            });
        } else {
            normalizedDepartment = [];
        }

        const locationValue = employee.location;
        const normalizedLocation = Array.isArray(locationValue)
            ? locationValue
            : typeof locationValue === 'string'
                ? locationValue.split(',').map((l) => l.trim())
                : [];

        const branchValue = employee.branch;
        const normalizedBranch = Array.isArray(branchValue)
            ? branchValue
            : typeof branchValue === 'string'
                ? branchValue.split(',').map((b) => b.trim())
                : [];

        setSelectedEmployee(employee);
        setEditFormData({
            ...employee,
            department: normalizedDepartment,
            location: normalizedLocation,
            branch: normalizedBranch,
        });
        setIsEditing(true);
        setShowDetails(true);
    };

    const handleDeleteClick = (employee) => {
        setSelectedEmployee(employee);
        setShowDeleteConfirm(true);
    };

    const handleChangePasswordClick = (employee) => {
        setSelectedEmployee(employee);
        setShowPasswordModal(true);
    };

    const handleChangePassword = async (passwordData) => {
        setPasswordLoading(true);
        try {
            await changeEmployeePassword(passwordData);
            showSuccess('Password changed successfully!');
            setShowPasswordModal(false);
        } catch (err) {
            console.error('Error changing password:', err);
            showError('Failed to change password');
        } finally {
            setPasswordLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditFormData({ ...editFormData, [name]: value });
    };

    const handleSaveChanges = async () => {
        try {
            // Make API call to update employee
            await updateEmployee(editFormData.emp_id, editFormData);

            // Update the employee in the list
            const updatedEmployees = employees.map(emp =>
                emp.emp_id === editFormData.emp_id ? editFormData : emp
            );
            setEmployees(updatedEmployees);

            // Exit edit mode
            setIsEditing(false);
            setSelectedEmployee(null);
            setShowDetails(false);
        } catch (err) {
            console.error('Error updating employee:', err);
            showError('Failed to update employee');
        }
    };

    const handleDeleteEmployee = async () => {
        try {
            // Make API call to delete employee
            await deleteEmployee(selectedEmployee.emp_id);

            // Remove the employee from the list
            const updatedEmployees = employees.filter(emp => emp.emp_id !== selectedEmployee.emp_id);
            setEmployees(updatedEmployees);

            // Close the delete confirmation and details modal
            setShowDeleteConfirm(false);
            setShowDetails(false);
            setSelectedEmployee(null);
        } catch (err) {

            console.error(
                'Error deleting employee:',
                err
            );

            showError(
                err.message ||
                'Failed to delete employee'
            );

        }
    };

    const handleCloseDetails = () => {
        setShowDetails(false);
        setIsEditing(false);
        setSelectedEmployee(null);
    };

    const handleCancelDelete = () => {
        setShowDeleteConfirm(false);
    };

    const handlePageChange = (newPage) => {

        if (
            newPage >= 1 &&
            newPage <= totalPages
        ) {

            setPage(newPage);

            setShouldFetch(true);

        }

    };

    const handleItemsPerPageChange = (newLimit) => {

        setLimit(newLimit);

        setPage(1);

        setShouldFetch(true);

    };

    // Updated handler for unified search
    const handleSearchChange = (e) => {

        const value = e.target.value;

        setSearchQuery(value);

        if (noResultsFound) {
            setNoResultsFound(false);
        }

        setPage(1);
        setShouldFetch(true);

    };
    const buildFilters = () => {

        const filters = {
            page,
            limit
        };

        if (searchQuery.trim()) {
            filters.search =
                searchQuery.trim();
        }

        if (selectedBranches.length > 0) {
            filters.branch =
                selectedBranches.join(",");
        }

        if (selectedDepartments.length > 0) {
            filters.department =
                selectedDepartments.join(",");
        }

        if (selectedRoles.length > 0) {
            filters.role =
                selectedRoles.join(",");
        }

        if (selectedAccess !== "") {
            filters.has_access =
                selectedAccess;
        }

        if (lastLoginFilter) {

            filters.lastLoginFilter =
                lastLoginFilter;

        }

        if (loginFrom) {
            filters.loginFrom =
                loginFrom;
        }

        if (loginTo) {
            filters.loginTo =
                loginTo;
        }

        return filters;
    };
    const handleToggleAccess = async (employee) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/toggle-access/${employee.emp_id}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type":
                            "application/json"
                    },
                    body: JSON.stringify({
                        has_access:
                            !employee.has_access
                    }),
                }
            );
            const data =
                await response.json();
            if (!response.ok) {
                return showError(
                    data.message ||
                    "Failed to update access"
                );
            }
            // ✅ Update UI instantly
            setEmployees((prev) =>
                prev.map((emp) =>
                    emp.emp_id ===
                        employee.emp_id
                        ? {
                            ...emp,
                            has_access:
                                !emp.has_access
                        }
                        : emp
                )
            );
            showSuccess(data.message);
        } catch (error) {
            console.error(error);
            showError(
                "Failed to update employee access"
            );
        }
    };
    const handleReplaceClick = (
        employee
    ) => {

        setReplaceEmployee(employee);

        setShowReplaceModal(true);

    };
    const handleReplaceSubmit =
        async (data) => {

            try {

                await replaceEmployeeMapping({

                    oldEmpId:
                        replaceEmployee.emp_id,

                    newStaffEmpId:
                        data.newStaffEmpId,

                    newMentorEmpId:
                        data.newMentorEmpId

                });

                showSuccess(
                    "Employee mapping replaced successfully"
                );

                setShowReplaceModal(false);

                setReplaceEmployee(null);

            }

            catch (err) {

                showError(
                    err.message
                );

            }

        };
    // Show loading only on initial load
    if (loading && employees.length === 0 && !noResultsFound) return <div className="loading">Loading employees...</div>;

    // Show error only for actual API failures
    if (error) return <div className="error">{error}</div>;

    return (
        <div className="dashboard">

            {/* HEADER */}
            <div className="dashboard-header">
                <h1 className="dashboard-heading">
                    EMPLOYEE DASHBOARD
                </h1>

                <div className="flex items-center gap-3">



                    <UserProfileDropdown />
                    <ProfileAvatarpp />
                </div>
            </div>

            {/* COUNT CARD */}
            <RecordCountCard
                currentCount={employees.length}
                totalCount={totalRecords}
            />

            {/* FILTER SECTION */}
            <div className="head">
                <h3>Search Employees</h3>

            </div>
            <EmployeeFilterSummary

                selectedBranches={selectedBranches}
                selectedDepartments={selectedDepartments}
                selectedRoles={selectedRoles}

                setSelectedBranches={setSelectedBranches}
                setSelectedDepartments={setSelectedDepartments}
                setSelectedRoles={setSelectedRoles}
                selectedAccess={selectedAccess}
                loginFrom={loginFrom}
                loginTo={loginTo}

                setSelectedAccess={setSelectedAccess}
                setLoginFrom={setLoginFrom}
                setLoginTo={setLoginTo}

                clearAllFilters={() => {

                    setSelectedBranches([]);
                    setSelectedDepartments([]);
                    setSelectedRoles([]);
                    setLastLoginFilter("");
                    setSelectedAccess("");
                    setLoginFrom("");
                    setLoginTo("");
                    setShouldFetch(true);

                }}
            />

            <EmployeeFilters

                availableBranches={availableBranches}
                departments={departments}

                selectedBranches={selectedBranches}
                selectedDepartments={selectedDepartments}
                selectedRoles={selectedRoles}
                lastLoginFilter={lastLoginFilter}
                setLastLoginFilter={setLastLoginFilter}

                setSelectedBranches={setSelectedBranches}
                setSelectedDepartments={setSelectedDepartments}
                setSelectedRoles={setSelectedRoles}
                selectedAccess={selectedAccess}
                setSelectedAccess={setSelectedAccess}

                loginFrom={loginFrom}
                setLoginFrom={setLoginFrom}

                loginTo={loginTo}
                setLoginTo={setLoginTo}

                onApply={() => {

                    setPage(1);
                    setShouldFetch(true);

                }}


                onClear={() => {
                    setSearchQuery('');

                    setSelectedBranches([]);
                    setSelectedDepartments([]);
                    setSelectedRoles([]);

                    setShouldFetch(true);

                }}
            />
            <div className="search-bar-container">

                <div className="searchsr-bar">

                    <input
                        type="text"
                        placeholder="Search by Employee Name..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className="search-input"
                        autoComplete="off"
                    />
                    <button
                        className="add-user-btn"
                        onClick={() => setShowForm(true)}
                    >
                        Create Employee +
                    </button>
                </div>

            </div>
            {/* TABLE */}
            <EmployeeGrid
                employees={employees}
                onEditClick={handleEditClick}
                onDeleteClick={handleDeleteClick}
                onToggleAccess={handleToggleAccess}
                onChangePasswordClick={handleChangePasswordClick}
                onReplaceClick={handleReplaceClick}
                loading={loading}
                userRole={userRole}
            />

            {/* PAGINATION */}
            <Pagination
                currentPage={page}
                totalPages={totalPages}
                itemsPerPage={limit}
                onPageChange={handlePageChange}
                onItemsPerPageChange={
                    handleItemsPerPageChange
                }
                buildFilters={buildFilters}

            />

            {/* Employee Edit Modal */}
            {showDetails && isEditing && (
                <EmployeeDetailsModal
                    formData={editFormData}
                    availableLocations={availableLocations}
                    availableBranches={availableBranches}
                    onInputChange={handleInputChange}
                    onSave={handleSaveChanges}
                    onClose={handleCloseDetails}
                />
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteConfirm && (
                <DeleteConfirmationModal
                    employee={selectedEmployee}
                    onConfirmDelete={handleDeleteEmployee}
                    onCancel={handleCancelDelete}
                />
            )}

            {/* Password Change Modal */}
            {showPasswordModal && selectedEmployee && (
                <div className="modal-overlay">
                    <div className="employee-details-modal">
                        <div className="modal-header">
                            <h2>Change Password</h2>

                            <button
                                className="close-btn"
                                onClick={() => setShowPasswordModal(false)}
                            >
                                ×
                            </button>
                        </div>

                        <div className="modal-content">
                            <PasswordManagement
                                employeeId={selectedEmployee.emp_id}
                                onChangePassword={handleChangePassword}
                                loading={passwordLoading}
                            />
                        </div>
                    </div>
                </div>
            )}
            {showForm && (
                <EmployeeForm
                    userRole={userRole}
                    branches={branches}
                    locations={locations}
                    onClose={() => setShowForm(false)}
                />
            )}
            <ReplaceEmployeeModal

                show={showReplaceModal}

                onClose={() =>
                    setShowReplaceModal(false)
                }

                onSubmit={
                    handleReplaceSubmit
                }

                replaceEmployee={
                    replaceEmployee
                }

            />
        </div>
    );
};

export default ViewEmployees;